<template>
    <section
        v-if="!(isMobile && slice.primary.hideInMobile)"
        :class="['slice', 'slice-reinsurance', {'slice-reinsurance--isMobile': slice.primary.hideInMobile}]"
        aria-label="partners"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title.length" :field="slice.primary.title" class="slice-title" />

            <div :class="{'slice-reinsurance__logos': true, 'slice-reinsurance__logos--withColor': slice.primary.withColor}">
                <PrismicImage
                    v-for="(item, i) in slice.items"
                    :key="`slice-item-${i}`"
                    :field="item.brandLogo"
                    sizes="mobile:100px wide:200px"
                    :class="{bigger: item.isBigger}"
                />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import type {ReinsuranceSliceSlice} from '@prismicio-types';
    import {useBreakpoints} from '#imports';

    defineProps(getSliceComponentProps<ReinsuranceSliceSlice>());

    const {isMobile} = useBreakpoints();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-reinsurance {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin: auto;

        &--isMobile {
            @include mq.screen_sm(max) {
                display: none;
            }
        }

        @include mq.screen_sm(max) {
            margin: 0 var(--joy-core-spacing-7);
        }

        &__logos {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            gap: var(--joy-core-spacing-5) var(--joy-core-spacing-5);
            filter: grayscale(100%);
            margin-top: var(--joy-core-spacing-6);

            &--withColor {
                filter: none;
            }

            @include mq.screen_md(min) {
                gap: var(--joy-core-spacing-8) var(--joy-core-spacing-12);
                margin-top: var(--joy-core-spacing-10);
            }

            img {
                max-width: 70px;
                width: auto;
                object-fit: contain;
                height: 24px;

                &.bigger {
                    height: 32px;
                }

                @include mq.screen_sm(min) {
                    max-width: 100px;
                    height: 40px;

                    &.bigger {
                        height: 56px;
                    }
                }
            }
        }
    }
</style>
